import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AjaxService } from '../core';

@Component({
  selector: 'app-connect-payment',
  templateUrl: './connect-payment.component.html',
  styleUrls: ['./connect-payment.component.less']
})
export class ConnectPaymentComponent implements OnInit {
 

  constructor(private route:ActivatedRoute ,    private _ajaxService: AjaxService ) { }

  details:any;

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.details = (params && params.details) ? JSON.parse(atob(params.details)) : undefined;
      console.log(this.details); 
    return this.details;
  });
  }

  pay() {
    let isProd :any;
    const value = this.details;
    if (window.location.host.includes('app.iylon.com')) {
      isProd = true;
    } else {
      isProd = false;
    }
    const reqObj = {
      amount: parseInt(value.Amount)*100 ,
      isProd: isProd,
      isIylonConnect : true,
      connectDetails:value
    };
    this._ajaxService.post('/miscellaneous/payment', reqObj).subscribe((response) => {
      if (response.useStripePaymentGateway){
       // this.paymentData.stripeData = response.paymentIntent;
        //this._route.navigate(['/payment-Page/', btoa(unescape(encodeURIComponent(JSON.stringify(this.paymentData))))]);
      }else{
        if (!window.location.host.includes('app.iylon.com')) {
          alert('We have noticed you are in test mode. Please use below credit card detials.\nCard Number: 4012888888881881\nExpiry Date: Any future date\nCVV: Any 3 digit number\nName: Your name');
        }
        window.location = response.forwardLink;
      }
    });
  }

}
